import React from "react";
import ReactMarkdown from "react-markdown";
import { hideLoadingScreen } from "@/modules/loading";

import "./style.scss";

interface IProps {
	match?: any;
}

interface IState {
	readme: string;
}

export default class Readme extends React.Component<IProps, IState> {
	state = {
		readme: null
	};
	
	componentDidMount() {
		const pageName = this.props.match.params.page || "index";
		
		fetch("/docs/" + pageName + ".md")
			.then(res => res.text())
			.then(text => {
				this.setState({readme: text}, () => {
					hideLoadingScreen();
				});
			});
	}
	
	render() {
		return (this.state.readme) ? (
			<div className="markdown-body">
				<ReactMarkdown source={this.state.readme} />
			</div>
		) : null;
	}
	
}